var defaultGlobalSettings = {
  dimApiEnabled: true,
  destinyProfileMinimumRefreshInterval: 15,
  destinyProfileRefreshInterval: 120,
  autoRefresh: true,
  refreshProfileOnVisible: true,
  dimProfileMinimumRefreshInterval: 600,
  showIssueBanner: false,
  lastUpdated: 0
};

var TagVariant = {
  PVP: 1,
  PVE: 2
};

var AssumeArmorMasterwork = {
  None: 1,
  Legendary: 2,
  All: 3,
  ArtificeExotic: 4
};
var LoadoutSort = {
  ByEditTime: 0,
  ByName: 1
};
var defaultLoadoutParameters = {
  statConstraints: [{
    statHash: 2996146975
  }, {
    statHash: 392767087
  }, {
    statHash: 1943323491
  }, {
    statHash: 1735777505
  }, {
    statHash: 144602215
  }, {
    statHash: 4244567218
  }],
  mods: [],
  assumeArmorMasterwork: AssumeArmorMasterwork.None,
  autoStatMods: true,
  includeRuntimeStatBenefits: true,
  clearArmor: false,
  clearMods: false,
  clearWeapons: false
};

var SearchType = {
  Item: 1,
  Loadout: 2
};

var InfuseDirection = {
  INFUSE: 0,
  FUEL: 1
};
var ItemPopupTab = {
  Overview: 0,
  Triage: 1
};
var VaultWeaponGroupingStyle = {
  Lines: 0,
  Inline: 1
};
var defaultSettings = {
  itemQuality: true,
  showNewItems: false,
  characterOrder: 'mostRecent',
  itemSortOrderCustom: ['primStat', 'name'],
  itemSortReversals: [],
  charCol: 3,
  charColMobile: 4,
  itemSize: 50,
  collapsedSections: {},
  completedRecordsHidden: false,
  redactedRecordsRevealed: false,
  farmingMakeRoomForItems: true,
  inventoryClearSpaces: 1,
  hideCompletedRecords: false,
  customCharacterSort: [],
  infusionDirection: InfuseDirection.INFUSE,
  language: 'en',
  wishListSource: 'https://raw.githubusercontent.com/48klocs/dim-wish-list-sources/master/voltron.txt',
  loParameters: {},
  loStatConstraintsByClass: {},
  customTotalStatsByClass: {},
  organizerColumnsWeapons: ['icon', 'name', 'dmg', 'power', 'locked', 'tag', 'wishList', 'archetype', 'perks', 'notes'],
  organizerColumnsArmor: ['icon', 'name', 'power', 'dmg', 'energy', 'locked', 'tag', 'ghost', 'modslot', 'perks', 'stats', 'customstat', 'notes'],
  organizerColumnsGhost: ['icon', 'name', 'locked', 'tag', 'perks', 'notes'],
  compareBaseStats: false,
  sidecarCollapsed: false,
  singleCharacter: false,
  badgePostmaster: true,
  perkList: true,
  loadoutSort: LoadoutSort.ByEditTime,
  itemFeedHideTagged: true,
  itemFeedExpanded: false,
  hidePullFromPostmaster: false,
  descriptionsToDisplay: 'both',
  compareWeaponMasterwork: false,
  itemFeedWatermark: '0',
  customStats: [],
  autoLockTagged: false,
  theme: 'default',
  sortRecordProgression: false,
  vendorsHideSilverItems: false,
  vaultWeaponGrouping: '',
  vaultWeaponGroupingStyle: VaultWeaponGroupingStyle.Lines,
  itemPopupTab: ItemPopupTab.Overview
};

export { AssumeArmorMasterwork, InfuseDirection, ItemPopupTab, LoadoutSort, SearchType, TagVariant, VaultWeaponGroupingStyle, defaultGlobalSettings, defaultLoadoutParameters, defaultSettings };
